import React, { Component } from "react";
import NewPasswordPage from "./otpLogin.jsx"
import axios from 'axios';
import { baseURL } from "../../../constants/applicationConstants.js";
import { Loader } from "../loader/loader.jsx";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { mixPannelEvent } from "../../../shared/helper.js";

export class OtpLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {

                newpassword: "",
            },
            formError: {},
            formSubmitButtonDisable: true,
            isLoading: false,
            timerStart: true,            
        };
    }


    onTimerComplete = () => {
        this.setState({ timerStart: false })
    }





    onResendOTPClick = () => {
        let flowType = localStorage.getItem("flowType")

        let data = localStorage.getItem("resendOtpData")
        let payload = data && JSON.parse(data)

        this.setState({ isLoading: true });
        axios.post(`${baseURL}/${flowType === "expert" ? "expert" : flowType === "institute" ? "institute" : "customer"}/login`, payload).then((res) => {

            toast.success("Login OTP sent to you Email successfully");
            localStorage.setItem("otpValidateToken", JSON.stringify(res.data?.data?.tokenValidate));

            this.setState({ isLoading: false,timerStart:true });

        }).catch((res) => {
            toast.error(res?.response.data.error.message);
            this.setState({ isLoading: false });
        })
    }
    onInputChangeHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },

                    },
                    () => this.isFromSubmissionBlock()
                );
            } else {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            }
        } else {
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    };
    success = (e) => {
        toast.success("Congrats ! Expert created!");
        let oldToken = localStorage.getItem("instituteExpertToken")
        localStorage.setItem("token", oldToken);
        setTimeout(() => {
            this.props.history.push("/dashboard");
            localStorage.removeItem("expertId");
            localStorage.removeItem("expertData");
            localStorage.removeItem("description");

            localStorage.setItem('flowName', 'institute')
            localStorage.setItem('flowType', 'institute')
            localStorage.removeItem("instituteExpert");
            localStorage.removeItem("instituteExpertToken");

            // window.location.reload()
        }, 2000)
        // swal({
        //   title: "Congrats ! Expert created!",
        //   icon: "Success",
        //   buttons: [
        //     'Keep Logged in!',
        //     'Go to dashboard'
        //   ],
        //   dangerMode: true,
        // }).then(function (isConfirm) {
        //   if (isConfirm) {

        //     // localStorage.removeItem("expertId");
        //     // localStorage.removeItem("expertData");
        //     // localStorage.setItem('flowName', 'institute')
        //     // localStorage.setItem('flowType', 'institute')
        //     // localStorage.removeItem("instituteExpert");

        //     setTimeout(() => {

        //       window.location.reload()
        //     }, 2000)

        //   } else {
        //     //   swal("Cancelled", "Your imaginary file is safe :)", "error");
        //   }
        // })

    }

    onTouchHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value === "") {
            this.setState({
                formError: {
                    ...this.state.formError,
                    [name]: "req",
                },
            });
        } else {
            if (!this.inputRegexValidation(name, value)) {
                this.setState({
                    formError: {
                        ...this.state.formError,
                        [name]: "regx",
                    },
                });
            }
        }
    };

    inputRegexValidation = (name, value) => {
        let passwordRegex =
            /[^\n]+/;
        if (name === "currentpassword") {
            if (!passwordRegex.test(value)) {
                return false;
            } else {
                return true;
            }
        } else {
            if (!passwordRegex.test(value)) {
                return false;
            } else {
                return true;
            }
        }
    };

    isFromSubmissionBlock = () => {
        let { newpassword } = this.state.formData;
        if ((newpassword)) {
            if (
                !this.inputRegexValidation("newpassword", newpassword)
            ) {
                this.setState({
                    formSubmitButtonDisable: true,
                });
            }
        } else {
            this.setState({
                formSubmitButtonDisable: true,
            });
        }
    };
    formSubmitHandler = (e) => {
        const loginSuccess = {
            eventName: "login_success",
            data: {
              name: "login_success"
            }
          }

        e.preventDefault();
        let flowType = localStorage.getItem("flowType")

        const { newpassword } = this.state.formData;
        const token = JSON.parse(localStorage.getItem('otpValidateToken'));
        const resendOtpData = JSON.parse(localStorage.getItem('resendOtpData'));

        let data = {
            "otp": newpassword,
            "tokenValidate": token,
        }

        this.setState({
            isLoading: true
        })
        let expertId = localStorage.getItem("expertId") && JSON.parse(localStorage.getItem("expertId"))
        if (expertId || flowType === "expert") {
            delete data.category
        }

        if (flowType === "customer") {
            data.email = resendOtpData?.email
        }

        let fullUrl = flowType === "customer" ? `${baseURL}/customer/loginOtpValidation` : `${baseURL}/${flowType === "expert" ? "expert" : flowType === "customer" ? "customer" : "institute"}/otpValidation`;

        axios.post(fullUrl, data, {
            headers: {
                token: token
            }
        }).then(res => {
            if (res.data.success) {
                localStorage.removeItem("otpValidateToken")
                this.setState({
                    isLoading: false
                })
                if (flowType === "customer") {
                    localStorage.setItem("auth", JSON.stringify(res?.data?.data));
                    localStorage.setItem("token", JSON.stringify(res.data?.data?.accessToken));
                    localStorage.setItem("masterID", JSON.stringify(res.data?.data?.customerId));
                    localStorage.setItem("customerId", JSON.stringify(res.data?.data?.customerId));
                    localStorage.setItem("loginData", JSON.stringify(res.data?.data));
                    localStorage.setItem('flowName', 'customer')
                    localStorage.setItem('flowType', 'customer')
                    localStorage.setItem("loginAs", 'customer')
                    localStorage.removeItem("resendOtpData")
                    mixPannelEvent(loginSuccess)

                    toast.success("You have logged-in successfully");
                    setTimeout(() => {
                        this.props.history.push("/customerDashBoard");
                        window.location.reload()
                    }, 2000)
                } else if (flowType === "expert") {
                    localStorage.setItem("auth", JSON.stringify(res?.data?.data));
                    localStorage.setItem("token", JSON.stringify(res.data?.data?.accessToken));
                    localStorage.setItem("masterID", JSON.stringify(res.data?.data?.expertId));
                    localStorage.setItem("expertId", JSON.stringify(res.data?.data?.expertId));
                    localStorage.setItem("loginData", JSON.stringify(res.data?.data));
                    localStorage.setItem("loginAs", 'expert')
                    localStorage.setItem('flowName', 'expert')
                    localStorage.setItem('flowType', 'expert')
                    localStorage.removeItem("resendOtpData")
                    mixPannelEvent(loginSuccess)

                    toast.success("You have logged-in successfully");
                    if (!res.data?.data?.isPermanentPasswordSet) {
                        setTimeout(() => {
                            this.props.history.push("/saveNewPassword");
                            // window.location.reload()
                        }, 2000)
                    } else {
                        setTimeout(() => {
                            this.props.history.push("/expertDashboardHome");
                            // window.location.reload()
                        }, 2000)

                    }
                } else {
                    localStorage.setItem("auth", JSON.stringify(res?.data?.data));
                    localStorage.setItem("token", JSON.stringify(res.data?.data?.accessToken));
                    localStorage.setItem("isLoggedIn", true);
                    localStorage.setItem("masterID", JSON.stringify(res.data?.data?.instituteId));
                    localStorage.setItem("loginData", JSON.stringify(res.data?.data));
                    localStorage.setItem("loginAs", 'institute')
                    localStorage.setItem('flowName', 'institute')
                    localStorage.setItem('flowType', 'institute')
                    localStorage.removeItem("resendOtpData")
                    mixPannelEvent(loginSuccess)

                    toast.success("You have logged-in successfully");


                    if (!res.data?.data?.isPermanentPasswordSet) {
                        setTimeout(() => {
                            this.props.history.push("/saveNewPassword");
                            window.location.reload()
                        }, 2000)
                    } else {
                        setTimeout(() => {
                            this.props.history.push("/dashboard");
                            window.location.reload()
                        }, 2000)

                    }
                }

                // window.location.reload()
            } else {

                toast.error(res?.data?.error?.message ?? "something went wrong");
                mixPannelEvent({
                    eventName: "login_failed",
                    data: {
                      name: res?.data?.error?.message
                    }
                  })
                this.setState({
                    isLoading: false
                })
            }
        }).catch(err => {

            toast.error(err?.response?.data?.error?.message ?? "something went wrong");
            mixPannelEvent({
                eventName: "login_failed",
                data: {
                  name: err?.response?.data?.error?.message
                }
              })
            this.setState({
                isLoading: false
            })
        })
    };



    render() {

        return (
            <>
                <NewPasswordPage
                    formData={this.state.formData}
                    onInputChangeHandler={this.onInputChangeHandler}
                    onTouchHandler={this.onTouchHandler}
                    formSubmitButtonDisable={this.state.formSubmitButtonDisable}
                    onResendOTPClick={this.onResendOTPClick}
                    onTimerComplete={this.onTimerComplete}

                    formError={this.state.formError}
                    formSubmitHandler={this.formSubmitHandler}
                    timerStart={this.state.timerStart}

                />
                {this.state.isLoading && <Loader />}

            </>
        );
    }
}

export default OtpLogin;


